import styled from 'styled-components';
import {Container} from 'react-bootstrap';

export const ProfileStatsStyled = styled.div`
  display: flex;
  justify-content: space-between;
  .dash_1 {
    flex-basis: 24%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: auto;
    height: 177px;
    background: rgba(255, 255, 255, .5);
    border: 1px solid var(--bllink-blue);
    border-radius: 50px;
    padding: 20px;
    p {
      font-family: var(--bllink-font-primary);
      font-size: 15px;
      line-height: 23px;
      text-align: center;
      color: var(--bllink-gray);
    }
    h3 {
      margin: auto 0 0;
      font-family: var(--bllink-font-headers);
      font-size: 30px;
      line-height: 1;
      text-align: center;
      color: var(--bllink-gray);
    }
    &-image {
      min-height: 50px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .currency_header {
    display: flex;
    gap: ${({ turnCurrency }) => turnCurrency ? 0 : '5px'};
    flex-direction: ${({ turnCurrency }) => turnCurrency ? 'row-reverse' : 'row'}
  }

  /* Mobile devices smaller than an ipad */
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 20px;

    .dash_1 {
      margin: 0 !important;
    }
  }

`;

export const BuildingManagerProfileStyled = styled(Container)`
  .back-link {
    a {
      display: flex;
      align-items: center;
      color: var(--bllink-gray);
    }
    img {
      margin-inline-end: 10px;
    }
    &.ltr img {
      transform: rotate(180deg);
    }
  }
  .partner-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 750px;
    margin: 0 auto 40px;
    .action-btn {
      max-width: 350px;
    }
  }
  .profile-charts {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    .align-paye_chart {
      width: 40%;
    }
    .align-line_chart {
      width: 57%;
    }
  }
  .paye_chart{
    width: 100%;
  }
  
  .canvas-pie {
    width: 288px;
    margin: 0 auto;
  }

  .align-paye_chart {
    padding-inline-start: 0px!important;
    padding-inline-end: 15px;
  }
  .align-line_chart {
    padding-inline-end: 0px!important;
    padding-inline-start: 15px;
  }

  /* Desktop devices */
  @media screen and (min-width: 1024px) {

    .dash_1 {
      width: 260px;
    }

    .widgets-align {
      padding-right: 0;
    }

    .building-manager-buffer {
      height: 50px;
    }

    .building-manager-container {
      min-height: 500px;
    }


  }

  /* Mobile devices smaller than an ipad */
  @media screen and (max-width: 768px) {
    flex-direction: column;

    .partner-actions {
      flex-direction: column;
      
      .action-btn {
        margin: 7px 0;
      }
    }

    .profile-charts {
      flex-direction: column;

      .align-paye_chart, .align-line_chart {
        margin: 10px 0;
        width: 100%;
        padding-inline-end: 0;
        padding-inline-start: 0;
        
        .apexcharts-title-text {
          font-size: 12px;
        }
      }
    }

    .canvas-pie {
      margin: 0 !important;
    }
    

    

    .dash_1 {
      margin: 0 auto 13px auto;
    }
  }

`;
